/* ============================================================
   THEME SCRIPT — Zaghet Arredamenti
   Pattern Canvas, scroll animations, navbar, mobile menu,
   dropdown, counter, gallery filter, testimonial carousel,
   flip cards. Tutti i listener sono guardati da check
   sull'esistenza dell'elemento — sicuro su qualsiasi pagina.
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ============================================================
     1. ZAGHET ARCHITECTURAL PATTERN (Canvas)
     "cutout" mode (hero): linee scure su sfondo
     "overlay" mode (altre sezioni): linee bianche tenui
     ============================================================ */
  function drawZaghetPattern(el) {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    // Per parallax-divider il canvas è fixed full-viewport, quindi dimensioniamo
    // sulla viewport invece che sull'elemento (che è solo 50vh visibili).
    const isParallaxEl = el.classList.contains('parallax-divider');
    const w = isParallaxEl ? window.innerWidth : el.offsetWidth;
    const h = isParallaxEl ? window.innerHeight : el.offsetHeight;
    if (!w || !h) return;

    canvas.width = w * dpr;
    canvas.height = h * dpr;

    const isCutout = el.classList.contains('hero-card-lines')
                  || el.classList.contains('parallax-divider');
    const isParallax = el.classList.contains('parallax-divider');
    // Parallax: canvas fissato in viewport (come la parallax-img sopra), così
    // il pattern resta fermo mentre il content scorre sopra.
    canvas.style.cssText = isParallax
      ? 'position:fixed;top:0;left:0;width:100vw;height:100vh;pointer-events:none;z-index:0;'
      : 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:0;'
      + (isCutout ? '' : 'opacity:0.07;');
    ctx.scale(dpr, dpr);

    let s = 42;
    for (let i = 0; i < (el.className || '').length; i++) s = (s * 31 + el.className.charCodeAt(i)) | 0;
    // offsetTop (posizione nel DOCUMENTO, stabile) invece di getBoundingClientRect().top
    // (relativo al viewport, cambia con lo scroll): così quando iOS ridisegna il
    // pattern durante lo scroll il seed resta uguale → niente scatti delle linee.
    s = Math.abs(s + Math.round(el.offsetTop * 0.3)) || 1;
    function r() { s = (s * 48271) % 2147483647; return s / 2147483647; }

    const diag = Math.sqrt(w * w + h * h);
    const unit = diag / 800;
    const deg = Math.PI / 180;

    const thickMult = isCutout ? 1.4 : 1;
    const THIN = unit * 4 * thickMult;
    const MED  = unit * 8 * thickMult;
    const THICK = unit * 13 * thickMult;

    const groups = [
      { angle: 10,  count: isCutout ? 5 : 6 },
      { angle: -12, count: isCutout ? 4 : 5 },
      { angle: 63,  count: isCutout ? 5 : 6 },
      { angle: -60, count: isCutout ? 5 : 6 },
      { angle: 40,  count: isCutout ? 4 : 5 },
      { angle: -38, count: isCutout ? 4 : 4 },
    ];
    const thicknesses = [THIN, MED, MED, MED, THICK];

    ctx.strokeStyle = isCutout ? '#343434' : '#ffffff';
    ctx.lineCap = 'butt';

    groups.forEach(g => {
      const baseAngle = g.angle * deg;
      const perpX = -Math.sin(baseAngle);
      const perpY =  Math.cos(baseAngle);
      const span = Math.abs(perpX * w) + Math.abs(perpY * h);
      const step = span / (g.count + 1);
      const originX = w / 2 - perpX * span / 2;
      const originY = h / 2 - perpY * span / 2;

      for (let i = 1; i <= g.count; i++) {
        const offset = step * i + (r() - 0.5) * step * 0.15;
        const cx = originX + perpX * offset;
        const cy = originY + perpY * offset;
        const a = baseAngle + (r() - 0.5) * 6 * deg;
        const halfLen = diag;
        const dx = Math.cos(a) * halfLen;
        const dy = Math.sin(a) * halfLen;
        const thick = thicknesses[Math.floor(r() * thicknesses.length)];

        ctx.beginPath();
        ctx.moveTo(cx - dx, cy - dy);
        ctx.lineTo(cx + dx, cy + dy);
        ctx.lineWidth = Math.max(1, thick);
        ctx.stroke();
      }
    });

    ctx.globalCompositeOperation = 'source-over';

    const computed = window.getComputedStyle(el).position;
    if (computed === 'static') el.style.position = 'relative';

    if (el.firstChild) el.insertBefore(canvas, el.firstChild);
    else el.appendChild(canvas);
  }

  document.querySelectorAll('.geo-pattern, .page-hero, .hero-card-lines, .parallax-divider').forEach(drawZaghetPattern);

  let patternTimer, lastPatternW = window.innerWidth;
  window.addEventListener('resize', () => {
    // Su iOS lo scroll fa apparire/sparire la barra → resize di sola ALTEZZA.
    // Ridisegnare lì causa: (a) scatti del pattern (linee ricalcolate per h
    // diversa) e (b) lo scroll-anchoring sposta la pagina da sola (rimuovi+
    // riaggiungi canvas = "content change"). Quindi ridisegniamo SOLO se cambia
    // la LARGHEZZA (orientamento / resize reale), mai per il solo address-bar.
    if (window.innerWidth === lastPatternW) return;
    lastPatternW = window.innerWidth;
    clearTimeout(patternTimer);
    patternTimer = setTimeout(() => {
      document.querySelectorAll('.geo-pattern canvas, .page-hero canvas, .hero-card-lines canvas, .parallax-divider canvas').forEach(c => c.remove());
      document.querySelectorAll('.geo-pattern, .page-hero, .hero-card-lines, .parallax-divider').forEach(drawZaghetPattern);
    }, 400);
  });


  /* ============================================================
     2. HERO SCROLL — sequenza dissolve a 4 fasi
     Phase 1 (0-30%): sfondo scuro fade
     Phase 2 (20-55%): pattern lines scale + fade
     Phase 3 (35-65%): logo zoom + fade
     Phase 4 (60-85%): testo video appare con slide-up
     ============================================================ */
  const heroWrap = document.querySelector('.hero-wrap');
  const heroCard = document.getElementById('heroCard');
  const heroCardDark = document.getElementById('heroCardDark');
  const heroCardLines = document.getElementById('heroCardLines');
  const heroCardContent = document.getElementById('heroCardContent');
  const heroScrollInd = document.getElementById('heroScroll');
  const heroVideoText = document.getElementById('heroVideoText');
  const heroVideoActions = document.getElementById('heroVideoActions');
  if (heroWrap && heroCard) {
    const ease = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;

    const onHeroScroll = () => {
      const rect = heroWrap.getBoundingClientRect();
      const scrolled = -rect.top;
      const total = heroWrap.offsetHeight - window.innerHeight;
      const progress = Math.max(0, Math.min(1, scrolled / total));

      if (heroCardDark) {
        const darkPhase = ease(Math.max(0, Math.min(1, progress / 0.30)));
        heroCardDark.style.opacity = 1 - darkPhase;
      }
      if (heroCardLines) {
        const linesPhase = ease(Math.max(0, Math.min(1, (progress - 0.20) / 0.35)));
        const lineScale = 1 + linesPhase * 0.4;
        heroCardLines.style.opacity = 1 - linesPhase;
        heroCardLines.style.transform = `scale(${lineScale})`;
      }
      if (heroCardContent) {
        heroCardContent.style.animation = 'none';
        const logoPhase = ease(Math.max(0, Math.min(1, (progress - 0.35) / 0.30)));
        const logoScale = 1 + logoPhase * 0.35;
        heroCardContent.style.opacity = progress < 0.35 ? 1 : 1 - logoPhase;
        heroCardContent.style.transform = progress < 0.35 ? 'scale(1)' : `scale(${logoScale})`;
      }

      heroCard.style.pointerEvents = progress > 0.7 ? 'none' : '';
      heroCard.style.visibility = progress > 0.75 ? 'hidden' : 'visible';

      if (heroScrollInd) heroScrollInd.style.opacity = 1 - Math.min(1, progress / 0.15);

      if (heroVideoText) {
        const textPhase = ease(Math.max(0, Math.min(1, (progress - 0.60) / 0.25)));
        heroVideoText.style.opacity = textPhase;
        const tY = (1 - textPhase) * 30;
        // A riposo (tY ≈ 0) rimuoviamo l'inline transform: anche translateY(0)
        // crea uno stacking context che rompe backdrop-filter del btn-glass figlio.
        heroVideoText.style.transform = tY > 0.5 ? `translateY(${tY}px)` : '';
      }
      // Bottoni: animazione reversibile via transition CSS, classe toggle in
      // entrambe le direzioni (scroll down → reveal, scroll up → unreveal).
      if (heroVideoActions) {
        heroVideoActions.classList.toggle('revealed', progress > 0.45);
      }
    };
    window.addEventListener('scroll', onHeroScroll, { passive: true });
    onHeroScroll();
  }


  /* ============================================================
     2c. iOS 26 SAFARI — bottom toolbar trasparente, scura SOLO sull'hero
     Tecnica documentata (jahir.dev, nasedk.in): Safari 26 NON è transparency-
     driven, campiona il background-color di un elemento fixed vicino al bordo.
     #ios-toolbar-tint (vedi CSS) è quel sentinel: di default display:none →
     toolbar trasparente. Lo attiviamo (.is-dark = charcoal-dark) SOLO quando
     dietro la toolbar c'è l'hero, l'unico punto col bug del blocco scuro.
     Tutto il resto resta trasparente nativo. Solo mobile/iOS.
     ============================================================ */
  const tintEl = document.getElementById('ios-toolbar-tint');
  const mqTint = window.matchMedia('(max-width: 768px)');
  if (tintEl && mqTint.matches) {
    // La toolbar deve restare TRASPARENTE il più possibile. NIENTE luminanza
    // (leggeva male le foto e scattava su immagini non scure). Whitelist
    // strutturale: scuro SOLO sulle due zone davvero scure e full-bleed del
    // sito — l'HERO e i DIVIDER (immagini di sfondo fisse). Tutto il resto
    // (foto in sezione, gallery, card, contenuti) NON è hero/divider → resta
    // trasparente, sempre. elementFromPoint al fondo del viewport, risale al
    // contenitore zona con .closest. Per aggiungere una zona scura: estendi il
    // selettore qui sotto. Per renderlo ancora meno aggressivo: togli i divider.
    // solo l'hero: toolbar trasparente sui divider (l'immagine ora riempie la
    // finestra, quindi niente buco da nascondere → non serve scurire la toolbar).
    const DARK_ZONES = '.hero-sticky';
    let tintTicking = false;
    const updateTint = () => {
      tintTicking = false;
      const el = document.elementFromPoint(window.innerWidth / 2, window.innerHeight - 24);
      const dark = !!(el && el.closest(DARK_ZONES));
      tintEl.classList.toggle('is-dark', dark);
    };
    window.addEventListener('scroll', () => {
      if (!tintTicking) { tintTicking = true; requestAnimationFrame(updateTint); }
    }, { passive: true });
    window.addEventListener('resize', updateTint, { passive: true });
    updateTint();
  }


  /* ============================================================
     3. NAVBAR — toggle scrolled state
     Con hero (.hero-wrap): trasparente in cima, scrolled dopo 60px.
     Senza hero: sempre scrolled (testo charcoal su sfondo bianco).
     ============================================================ */
  // BARRE SAFARI (iOS 26.4/27): pilotiamo theme-color esplicitamente. Le barre
  // seguono la navbar: DARK sull'hero (navbar trasparente), LIGHT quando scrolled/
  // bianca o a menu aperto. Da iOS 26.4 gli update dinamici sono di nuovo rispettati
  // → niente più scatti di colore né blocco bianco a menu aperto.
  const themeMeta = document.getElementById('theme-color-meta');
  let menuIsOpen = false;
  const updateThemeColor = () => {
    if (!themeMeta) return;
    const nb = document.getElementById('navbar');
    const light = menuIsOpen || !nb || nb.classList.contains('scrolled');
    themeMeta.setAttribute('content', light ? '#FFFFFF' : '#1A1A1A');
  };

  const navbar = document.getElementById('navbar');
  if (navbar) {
    // Trigger element: home hero, oppure page-hero con sfondo immagine
    // (le pagine /cucine, /camere, /chi-siamo etc hanno page-hero-img).
    // Sotto la sua altezza, navbar trasparente; sopra → scrolled bianca.
    const hero = document.querySelector('.hero-wrap, .page-hero-img');
    if (hero) {
      const getThreshold = () => Math.max(60, hero.offsetHeight * 0.6);
      let threshold = getThreshold();
      const onScroll = () => { navbar.classList.toggle('scrolled', window.scrollY > threshold); updateThemeColor(); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', () => { threshold = getThreshold(); onScroll(); }, { passive: true });
      onScroll();
    } else {
      navbar.classList.add('scrolled');
    }
  }
  updateThemeColor();


  /* ============================================================
     4. MOBILE MENU — burger + slide
     ============================================================ */
  const navToggle = document.getElementById('navToggle');
  const navMenu = document.getElementById('navMenu');
  if (navToggle && navMenu) {
    const navbarForMenu = document.getElementById('navbar');
    const setMenu = (open) => {
      navToggle.classList.toggle('active', open);
      navMenu.classList.toggle('active', open);
      if (navbarForMenu) navbarForMenu.classList.toggle('menu-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      // barre Safari bianche a menu aperto (coerenti col menu bianco); alla
      // chiusura ricalcola in base allo scroll → niente blocco.
      menuIsOpen = open;
      updateThemeColor();
      // Alla chiusura: poke di scroll per far ri-campionare le barre a iOS.
      if (!open) {
        const poke = () => {
          const y = window.scrollY;
          window.scrollTo({ top: y + 2, behavior: 'instant' });
          window.scrollTo({ top: y, behavior: 'instant' });
        };
        requestAnimationFrame(poke);
        setTimeout(poke, 460);
      }
    };
    navToggle.addEventListener('click', () => setMenu(!navMenu.classList.contains('active')));
    navMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setMenu(false)));
  }


  /* ============================================================
     5. NAV DROPDOWN — toggle separato dal link principale
     ============================================================ */
  document.querySelectorAll('.nav-dropdown-toggle').forEach(toggle => {
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const dropdown = toggle.closest('.nav-dropdown');
      document.querySelectorAll('.nav-dropdown.open').forEach(d => {
        if (d !== dropdown) d.classList.remove('open');
      });
      dropdown.classList.toggle('open');
    });
  });


  /* ============================================================
     6. REVEAL ANIMATIONS — IntersectionObserver
     ============================================================ */
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('active');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal, .reveal-left, .reveal-right').forEach(el => revealObs.observe(el));


  /* ============================================================
     7. COUNTER ANIMATION — stats con data-target
     ============================================================ */
  const ease = t => 1 - Math.pow(1 - t, 4);
  const animateCounter = (el) => {
    const target = parseInt(el.dataset.target, 10);
    if (isNaN(target)) return;
    const dur = 2200;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      el.textContent = Math.round(ease(p) * target);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const counterObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.querySelectorAll('[data-target]').forEach(animateCounter);
        counterObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.3 });
  document.querySelectorAll('.stats-section, .stats-grid').forEach(el => counterObs.observe(el));


  /* ============================================================
     8. TESTIMONIAL CAROUSEL — autoplay 6s
     ============================================================ */
  const thumbs = document.querySelectorAll('.tq-thumb');
  const tqText = document.getElementById('tqText');
  const tqName = document.getElementById('tqName');
  const tqAvatar = document.getElementById('tqAvatar');
  const tqDate = document.getElementById('tqDate');
  const tqToggle = document.getElementById('tqTranslateToggle');
  if (thumbs.length && tqText) {
    const TM = window.ZAGHET_TM || {};
    const LOCALE = (window.ZAGHET_LOCALE || 'it').toLowerCase().slice(0, 2);
    let current = thumbs[0];

    // Mostra il toggle "vedi originale" solo se NON siamo in IT e per la recensione
    // corrente esiste un originale italiano diverso dal testo (tradotto) mostrato.
    const refreshToggle = () => {
      if (!tqToggle) return;
      const orig = (current.dataset.original || '').trim();
      const shown = (current.dataset.text || '').trim();
      tqToggle.hidden = !(LOCALE !== 'it' && orig && orig !== shown);
      tqToggle.dataset.state = 'translated';
      tqToggle.classList.remove('is-original');
      const action = tqToggle.querySelector('.rt-action');
      if (action && TM.seeOriginal) action.textContent = TM.seeOriginal;
    };

    const switchTo = (thumb) => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      current = thumb;
      // Soft fade transition on text/author swap
      tqText.style.opacity = '0';
      setTimeout(() => {
        tqText.textContent = thumb.dataset.text;
        if (tqName) tqName.textContent = thumb.dataset.name;
        if (tqAvatar) tqAvatar.textContent = thumb.dataset.initials;
        if (tqDate) tqDate.textContent = thumb.dataset.date ? '· ' + thumb.dataset.date : '';
        tqText.style.opacity = '1';
        refreshToggle();
      }, 200);
    };
    thumbs.forEach(thumb => thumb.addEventListener('click', () => switchTo(thumb)));

    // Toggle traduzione automatica <-> originale italiano
    if (tqToggle) {
      tqToggle.addEventListener('click', () => {
        const action = tqToggle.querySelector('.rt-action');
        if (tqToggle.dataset.state === 'translated') {
          tqText.textContent = current.dataset.original || tqText.textContent;
          tqToggle.dataset.state = 'original';
          tqToggle.classList.add('is-original');
          if (action && TM.seeTranslation) action.textContent = TM.seeTranslation;
        } else {
          tqText.textContent = current.dataset.text || '';
          tqToggle.dataset.state = 'translated';
          tqToggle.classList.remove('is-original');
          if (action && TM.seeOriginal) action.textContent = TM.seeOriginal;
        }
      });
    }

    // Il testo mostrato (data-text) è ESATTAMENTE quello curato (tradotto da
    // Translate & Adapt in EN/DE); l'originale italiano (data-original) è già nel
    // markup (da text_original, non tradotto). Niente fetch, niente sostituzioni.
    refreshToggle();
    // Autoplay 6s — paused on hover
    const main = document.getElementById('testimonialMain');
    let idx = 0;
    let timer = setInterval(() => {
      idx = (idx + 1) % thumbs.length;
      switchTo(thumbs[idx]);
    }, 6000);
    if (main) {
      main.addEventListener('mouseenter', () => clearInterval(timer));
      main.addEventListener('mouseleave', () => {
        timer = setInterval(() => {
          idx = (idx + 1) % thumbs.length;
          switchTo(thumbs[idx]);
        }, 6000);
      });
    }
  }


  /* ============================================================
     9. FLIP CARDS — ora 100% CSS (checkbox :checked), nessun JS qui.
     ============================================================ */


  /* ============================================================
     10. SMOOTH ANCHOR LINKS — scroll alle ancore con offset navbar
     ============================================================ */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const href = anchor.getAttribute('href');
      if (href === '#' || href === '#!') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const offset = 80;
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });


  /* ============================================================
     11. LAZY IMAGE FADE-IN — opacity 0 → 1 al load
     ============================================================ */
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    if (img.complete) {
      img.classList.add('img-loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('img-loaded'));
    }
  });


  /* ============================================================
     12. GALLERY FILTER — filtra per data-category
     ============================================================ */
  const filterBtns = document.querySelectorAll('[data-filter]');
  if (filterBtns.length) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        filterBtns.forEach(b => { b.classList.remove('active'); b.classList.add('btn-outline'); });
        btn.classList.add('active');
        btn.classList.remove('btn-outline');
        const filter = btn.dataset.filter;
        document.querySelectorAll('.gallery-item').forEach(item => {
          if (filter === 'tutti' || item.dataset.category === filter || !item.dataset.category) {
            item.style.display = '';
          } else {
            item.style.display = 'none';
          }
        });
      });
    });
  }


  /* ============================================================
     13. GALLERY LIGHTBOX — click su .gallery-item[data-lightbox]
     apre l'immagine full-size con navigazione prev/next.
     I .gallery-item che sono <a> (home) navigano normalmente.
     ============================================================ */
  const lbItems = Array.from(document.querySelectorAll('.gallery-item[data-lightbox]'))
    .filter(el => el.tagName !== 'A');
  if (lbItems.length > 0) {
    const lb = document.createElement('div');
    lb.className = 'zaghet-lb';
    lb.setAttribute('aria-hidden', 'true');
    lb.innerHTML = ''
      + '<button class="zaghet-lb-btn zaghet-lb-close" aria-label="Chiudi">&times;</button>'
      + '<button class="zaghet-lb-btn zaghet-lb-prev" aria-label="Precedente">&#8249;</button>'
      + '<div class="zaghet-lb-stage"><img class="zaghet-lb-img" alt=""></div>'
      + '<button class="zaghet-lb-btn zaghet-lb-next" aria-label="Successiva">&#8250;</button>'
      + '<div class="zaghet-lb-counter"></div>';
    document.body.appendChild(lb);

    const lbImg = lb.querySelector('.zaghet-lb-img');
    const lbCounter = lb.querySelector('.zaghet-lb-counter');
    let cur = 0;

    function visibleItems() {
      // re-filter per i filtri categoria attivi (display:none non clickable)
      return lbItems.filter(el => el.offsetParent !== null);
    }
    function show() {
      const list = visibleItems();
      if (!list.length) return;
      cur = ((cur % list.length) + list.length) % list.length;
      const img = list[cur].querySelector('img');
      if (!img) return;
      const full = img.dataset.full || img.src;
      // Crossfade: fade out briefly, swap, fade in
      lb.classList.add('swapping');
      setTimeout(() => {
        lbImg.src = full;
        lbImg.alt = img.alt || '';
        lbCounter.textContent = (cur + 1) + ' / ' + list.length;
        requestAnimationFrame(() => lb.classList.remove('swapping'));
      }, 180);
    }
    function open(item) {
      const list = visibleItems();
      cur = list.indexOf(item);
      if (cur < 0) cur = 0;
      show();
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      lbImg.removeAttribute('src');
    }
    function nav(delta) { cur += delta; show(); }

    lbItems.forEach(item => {
      item.style.cursor = 'zoom-in';
      item.addEventListener('click', e => {
        // ignora se il click viene da un link interno (sicurezza)
        if (e.target.closest('a')) return;
        e.preventDefault();
        open(item);
      });
    });
    lb.querySelector('.zaghet-lb-close').addEventListener('click', close);
    lb.querySelector('.zaghet-lb-prev').addEventListener('click', () => nav(-1));
    lb.querySelector('.zaghet-lb-next').addEventListener('click', () => nav(1));
    lb.addEventListener('click', e => { if (e.target === lb || e.target.classList.contains('zaghet-lb-stage')) close(); });
    document.addEventListener('keydown', e => {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') nav(1);
      else if (e.key === 'ArrowLeft') nav(-1);
    });

    // Swipe touch su mobile
    let touchStartX = 0;
    lb.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) nav(dx < 0 ? 1 : -1);
    });
  }
});
